import { useState } from "react";
import {
  LayoutDashboard, FileText, TrendingDown, Calculator,
  BookOpen, BarChart3, ClipboardList, FolderKanban,
  LogOut, ChevronLeft, ChevronRight, Settings,
} from "lucide-react";

const MENU = [
  { key: "dashboard",    label: "Dashboard",       icon: LayoutDashboard },
  { key: "ingresos",     label: "Ingresos",        icon: FileText        },
  { key: "gastos",       label: "Gastos",          icon: TrendingDown    },
  { key: "iva",          label: "IVA / F29",       icon: Calculator      },
  { key: "libro",        label: "Libro Mayor",     icon: BookOpen        },
  { key: "balance",      label: "Balance General", icon: BarChart3       },
  { key: "cotizaciones", label: "Cotizaciones",    icon: ClipboardList   },
  { key: "proyectos",    label: "Proyectos",       icon: FolderKanban    }, // ← NUEVO
];

export default function Sidebar({ active, onNavigate, onLogout, empresa }) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <aside style={{
      width: collapsed ? 64 : 230,
      minHeight: "100vh",
      background: "#ffffff",
      borderRight: "1px solid #e2e8f0",
      display: "flex",
      flexDirection: "column",
      transition: "width .25s cubic-bezier(.4,0,.2,1)",
      position: "relative",
      zIndex: 10,
      flexShrink: 0,
    }}>
      {/* Logo */}
      <div style={{
        padding: collapsed ? "22px 0" : "22px 20px",
        borderBottom: "1px solid #e2e8f0",
        display: "flex",
        alignItems: "center",
        justifyContent: collapsed ? "center" : "space-between",
        overflow: "hidden",
      }}>
        {!collapsed && (
          <div>
            <div style={{ display:"flex", alignItems:"baseline" }}>
              <span style={{ fontSize:18, fontWeight:800, color:"#29abe2", letterSpacing:-1 }}>tu</span>
              <span style={{ fontSize:18, fontWeight:800, color:"#0d1117", letterSpacing:-1 }}>aplicacion</span>
            </div>
            <div style={{ fontSize:9, letterSpacing:2, color:"#94a3b8",
              textTransform:"uppercase", marginTop:2 }}>
              {empresa || "Sistema Contable"}
            </div>
          </div>
        )}
        {collapsed && (
          <div style={{ width:30, height:30, background:"#29abe2", borderRadius:7,
            display:"flex", alignItems:"center", justifyContent:"center",
            fontSize:12, fontWeight:800, color:"#fff" }}>
            tu
          </div>
        )}
      </div>

      {/* Toggle */}
      <button
        onClick={() => setCollapsed(!collapsed)}
        style={{
          position:"absolute", top:26, right:-11,
          width:22, height:22, borderRadius:"50%",
          background:"#ffffff", border:"1px solid #e2e8f0",
          color:"#94a3b8", cursor:"pointer",
          display:"flex", alignItems:"center", justifyContent:"center",
          zIndex:20, boxShadow:"0 1px 4px #0000001a",
        }}>
        {collapsed ? <ChevronRight size={11}/> : <ChevronLeft size={11}/>}
      </button>

      {/* Menú */}
      <nav style={{ flex:1, padding:"12px 0", overflowY:"auto" }}>
        {MENU.map(item => {
          const Icon = item.icon;
          const isActive = active === item.key;
          return (
            <button
              key={item.key}
              onClick={() => onNavigate(item.key)}
              title={collapsed ? item.label : ""}
              style={{
                width:"100%",
                display:"flex",
                alignItems:"center",
                gap:10,
                padding: collapsed ? "10px 0" : "10px 20px",
                justifyContent: collapsed ? "center" : "flex-start",
                background: isActive ? "#29abe210" : "transparent",
                border:"none",
                borderLeft: isActive ? "3px solid #29abe2" : "3px solid transparent",
                borderRight:"none", borderTop:"none", borderBottom:"none",
                color: isActive ? "#29abe2" : "#64748b",
                cursor:"pointer",
                fontFamily:"'DM Sans', sans-serif",
                fontSize:13,
                fontWeight: isActive ? 600 : 400,
                transition:"all .15s",
                whiteSpace:"nowrap",
                overflow:"hidden",
              }}
              onMouseEnter={e => {
                if (!isActive) {
                  e.currentTarget.style.background = "#f8fafc";
                  e.currentTarget.style.color = "#0d1117";
                }
              }}
              onMouseLeave={e => {
                if (!isActive) {
                  e.currentTarget.style.background = "transparent";
                  e.currentTarget.style.color = "#64748b";
                }
              }}>
              <Icon size={17} strokeWidth={isActive ? 2 : 1.5} style={{ flexShrink:0 }}/>
              {!collapsed && <span>{item.label}</span>}
            </button>
          );
        })}
      </nav>

      {/* Footer */}
      <div style={{ borderTop:"1px solid #e2e8f0", padding:"8px 0" }}>
        <button style={{
          width:"100%", display:"flex", alignItems:"center", gap:10,
          padding: collapsed ? "10px 0" : "10px 20px",
          justifyContent: collapsed ? "center" : "flex-start",
          background:"transparent", border:"none",
          color:"#94a3b8", cursor:"pointer",
          fontFamily:"'DM Sans', sans-serif", fontSize:13,
          transition:"all .15s",
        }}
          onMouseEnter={e => { e.currentTarget.style.color = "#0d1117"; }}
          onMouseLeave={e => { e.currentTarget.style.color = "#94a3b8"; }}>
          <Settings size={17} strokeWidth={1.5} style={{ flexShrink:0 }}/>
          {!collapsed && <span>Configuración</span>}
        </button>

        <button onClick={onLogout}
          title={collapsed ? "Cerrar sesión" : ""}
          style={{
            width:"100%", display:"flex", alignItems:"center", gap:10,
            padding: collapsed ? "10px 0" : "10px 20px",
            justifyContent: collapsed ? "center" : "flex-start",
            background:"transparent", border:"none",
            color:"#94a3b8", cursor:"pointer",
            fontFamily:"'DM Sans', sans-serif", fontSize:13,
            transition:"all .15s",
          }}
          onMouseEnter={e => { e.currentTarget.style.color = "#dc2626"; }}
          onMouseLeave={e => { e.currentTarget.style.color = "#94a3b8"; }}>
          <LogOut size={17} strokeWidth={1.5} style={{ flexShrink:0 }}/>
          {!collapsed && <span>Cerrar sesión</span>}
        </button>
      </div>

      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');`}</style>
    </aside>
  );
}
